import React, { useRef, useState } from "react";
// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react";

// Import Swiper styles
import "swiper/css";
import "swiper/css/navigation";

import "./styles.css";
import { Navigation } from "swiper";
interface IpropsProductDetailLeftSide  {}

const ProductDetailLeftSide = () => {
  return (
    <div className="productLeftSide">
      <Swiper navigation={true} modules={[Navigation]} className="mySwiper">
        <SwiperSlide><img src="https://res.cloudinary.com/ddoltb8nf/image/upload/v1662085729/just/711zqkSe8oL._AC_SL1500_-removebg-preview_kgqq36.png"/></SwiperSlide>
        <SwiperSlide><img src="https://res.cloudinary.com/ddoltb8nf/image/upload/v1662085729/just/711zqkSe8oL._AC_SL1500_-removebg-preview_kgqq36.png"/></SwiperSlide>
        <SwiperSlide><img src="https://res.cloudinary.com/ddoltb8nf/image/upload/v1662085729/just/711zqkSe8oL._AC_SL1500_-removebg-preview_kgqq36.png"/></SwiperSlide>
        <SwiperSlide><img src="https://res.cloudinary.com/ddoltb8nf/image/upload/v1662085729/just/711zqkSe8oL._AC_SL1500_-removebg-preview_kgqq36.png"/></SwiperSlide>
      </Swiper>
    </div>

  )
}

export default ProductDetailLeftSide